<mat-toolbar class="footer">
  SoftSoles
  <span class="spacer"></span>
  Facebook
</mat-toolbar>
